import React from 'react';
import HeaderContainer from 'containers/header';
import ErrorContainerConsecutive from 'containers/error/consecutive';
import FooterContainer from 'containers/footer';

const ErrorPageConsecutive = () => {
  return (
    <>
      <HeaderContainer />
      <ErrorContainerConsecutive />
      <FooterContainer />
    </>
  );
};

export default ErrorPageConsecutive;
